import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {ISegmentationRule} from './segmentation-rule.interface';
import {Check} from '@sparkware/app-utils';


export class SegmentationRule implements ISegmentationRule {
  constructor(private _ruleDefinition: any) {
  }

  get definition(): any {
    return this._ruleDefinition;
  }
  evaluate(context: IConfigurationEvaluationContext): boolean {
    if(Check.isArray(this.definition.rules)) {
      let innerRules = this.definition.rules.map(rule => context.createSegmentationRule(rule));
      let logicalOperator = context.createLogicalOperator(this.definition.condition || 'AND', innerRules);
      return logicalOperator.evaluate(context);
    } else {
      let operator = context.createComparisonOperator(this.definition.operator);
      let segmentValue = context.getSegmentValue(this.definition.id);
      return operator.compare(segmentValue, this.definition.value)
    }

  }
}




